import React from 'react';

import { FormOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import Messages from 'i18n/messages/home';
import { getFolderShortDetail } from 'services/folder';

export const WIDTH_CONTANT_PANE = 500;

const EditFolder = (props) => {
  const {
    selectedFolders,
    disabled,
    setEditFolderVisible,
    runFetchFolderShortContent,
  } = props;

  const checkDisableEdit = () => {
    if (disabled) return true;

    if (selectedFolders.length !== 1) return true;

    //* check selected folder
    const selectedFolder = selectedFolders[0];
    const isFolder = selectedFolder?.type?.toLowerCase() === 'folder';
    const isOwner = selectedFolder?.isOwner;
    const isEditable = selectedFolder?.editable;

    if (!isFolder) return true;

    return !isOwner && !isEditable;
  };

  const clickEditFolderHandler = () => {
    runFetchFolderShortContent(
      getFolderShortDetail({
        id: selectedFolders?.[0].id,
        IsLoadContent: false,
      })
    );

    setEditFolderVisible(true);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<FormOutlined />}
        label={Messages.editFoldersRibbon}
        disabled={checkDisableEdit()}
        onClick={clickEditFolderHandler}
      />
    </>
  );
};

export default EditFolder;
